// extracted by mini-css-extract-plugin
module.exports = {"range":"PlywoodRange_range__L59Os","range__title":"PlywoodRange_range__title__neWbt"};